<template>
  <div class="points-page">
    <van-nav-bar 
      title="我的积分" 
      left-text="返回" 
      left-arrow 
      @click-left="goBack"
      fixed 
      :placeholder="true" 
    >
      <template #right>
        <van-button size="small" type="default" @click="goToPointsLog" class="records-btn">
          积分明细
        </van-button>
      </template>
    </van-nav-bar>
    
    <div class="points-content">
      <!-- 积分显示卡片 -->
      <div class="points-card">
        <div class="points-header">
          <div class="points-info">
            <div class="points-number">{{ points }}</div>
            <div class="points-label">当前积分</div>
          </div>
        </div>
      </div>

      <!-- 规则说明切换 -->
      <div class="rule-tabs">
        <div 
          :class="['tab-item', activeTab === 'permissions' ? 'active' : '']"
          @click="activeTab = 'permissions'"
        >
          权限说明
        </div>
        <div 
          :class="['tab-item', activeTab === 'rules' ? 'active' : '']"
          @click="activeTab = 'rules'"
        >
          规则说明
        </div>
      </div>

      <!-- 权限说明列表 -->
      <div v-if="activeTab === 'permissions'" class="permissions-section">
        
        <div class="permissions-list">
          <div class="permission-item">
            <div class="permission-icon">V</div>
            <div class="permission-content">
              <div class="permission-title">抢单特权</div>
              <div class="permission-desc">等级v2及以上，大于1000积分，可以直接抢单，抢单价格为最高限价，先抢先得，抢单消耗800积分</div>
            </div>
          </div>
          <div class="permission-item">
            <div class="permission-icon">⚠️</div>
            <div class="permission-content">
              <div class="permission-title">禁止竞价</div>
              <div class="permission-desc">低于等于150积分，禁止参与实单报价！</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 积分奖励列表 -->
      <div v-if="activeTab === 'rules'" class="rules-section">
        <div class="reward-section">
          <div class="section-header">
            <div class="section-icon">🎁</div>
            <div class="section-title">积分奖励</div>
          </div>
          <div class="rules-list">
            <div class="rule-item" v-for="(item, index) in rewardRules" :key="index">
              <div class="rule-left">
                <span class="rule-name">{{ item.name }}</span>
              </div>
              <div class="rule-right">
                <!-- 多行奖励（如出票） -->
                <template v-if="item.multi">
                  <div class="rule-row" v-for="(row, idx) in item.multi" :key="idx">
                    <span class="rule-desc" v-if="row.desc">{{ row.desc }}: </span>
                    <span class="rule-points positive">+{{ row.points }}</span>
                    <span class="rule-unit" v-if="row.unit">/{{ row.unit }}</span>
                  </div>
                </template>
                <!-- 单行奖励 -->
                <template v-else>
                  <div class="rule-row">
                    <span class="rule-points positive">+{{ item.points }}</span>
                    <span class="rule-unit" v-if="item.unit">/{{ item.unit }}</span>
                  </div>
                  <span class="rule-desc" v-if="item.desc">{{ item.desc }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- 积分惩罚列表 -->
        <div class="penalty-section">
          <div class="section-header">
            <div class="section-icon">⚠️</div>
            <div class="section-title">积分惩罚</div>
          </div>
          <div class="rules-list">
            <div class="rule-item" v-for="(item, index) in penaltyRules" :key="index">
              <div class="rule-left">
                <span class="rule-name">{{ item.name }}</span>
              </div>
              <div class="rule-right">
                <!-- 多行惩罚 -->
                <template v-if="item.multi">
                  <div class="rule-row" v-for="(row, idx) in item.multi" :key="idx">
                    <span class="rule-desc" v-if="row.desc">{{ row.desc }}: </span>
                    <span class="rule-points negative">{{ row.points }}</span>
                    <span class="rule-unit" v-if="row.unit">/{{ row.unit }}</span>
                  </div>
                </template>
                <!-- 单行惩罚 -->
                <template v-else>
                  <div class="rule-row">
                    <span class="rule-points negative">{{ item.points }}</span>
                    <span class="rule-unit" v-if="item.unit">/{{ item.unit }}</span>
                  </div>
                  <span class="rule-desc" v-if="item.desc">{{ item.desc }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'

export default {
  name: 'PointsPage',
  data() {
    return {
      points: 0,
      activeTab: 'permissions',
      rewardRules: [
        { name: '初始注册', points: 200 },
        { name: '竞价一次', points: 1, unit: '单', desc: '每日最多10分' },
        {
          name: '出票',
          multi: [
            { points: 20, unit: '单', desc: '≤10分钟' },
            { points: 10, unit: '单', desc: '＞10分钟' }
          ]
        },
      ],
      penaltyRules: [
        {
          name: '接单待确认',
          multi: [
            { points: -10, unit: '单', desc: '主动弃单' },
            { points: -15, unit: '单', desc: '超时未处理' }
          ]
        },
        {
          name: '已确认接单弃单',
          multi: [
            { points: -25, unit: '单', desc: '≤10分钟' },
            { points: -50, unit: '单', desc: '＞10分钟' }
          ]
        },
        { name: '超时未报单', points: -150, unit: '单' },
        { name: '漏传票、少传票、传错票，引起客诉', points: -300, unit: '单' },
        { name: '不可调座下放调座', points: -200, unit: '单' },
        { name: '更新取票码', points: -100, unit: '次' },
        { name: '可调座未按照最优座位下单', points: -100, unit: '单' },
        { name: '上传虚假票码', points: -1000, unit: '单', desc: '包含出票后私自退款或先随意上传后修改' },
        { name: '恶意攻击，利用系统漏洞', points: -1000, unit: '单', desc: '并追究法律责任' }
      ]
    }
  },
  created() {
    this.getUserPoints();
    // 如果从其他页面传递了积分参数，优先使用传递的参数
    if (this.$route.query.points) {
      this.points = parseInt(this.$route.query.points) || 0;
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    // 获取用户积分
    getUserPoints() {
      Api.getUserPoints().then(res => {
        // 如果没有从路由传递积分参数，才使用API返回的积分
        if (!this.$route.query.points) {
          this.points = res.points || 0;
        }
      }).catch(error => {
        console.error('获取积分失败:', error);
      });
    },
    goToPointsLog() {
      this.$router.push('/points/log');
    }
  }
}
</script>

<style lang="scss" scoped>
.points-page {
  background-color: #f7f7fa;
  min-height: 100vh;

  .records-btn {
    font-size: 12px;
    height: 28px;
    padding: 0 12px;
    border-radius: 6px;
    border: 1px solid #667eea;
    background: white;
    color: #667eea;
    font-weight: 500;
    transition: all 0.3s ease;

    &:active {
      background: rgba(102, 126, 234, 0.1);
      transform: scale(0.95);
    }
  }

  .points-content {
    padding: 16px;

    .points-card {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 16px;
      padding: 20px;
      margin-bottom: 16px;
      box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
      text-align: center;

      .points-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .points-info {
          .points-number {
            font-size: 28px;
            font-weight: 700;
            color: white;
            margin-bottom: 4px;
            letter-spacing: 0.5px;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          }

          .points-label {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.9);
            font-weight: 500;
            letter-spacing: 0.3px;
          }
        }
      }
    }

    .rule-tabs {
      display: flex;
      background: white;
      border-radius: 16px;
      margin-bottom: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      overflow: hidden;

      .tab-item {
        flex: 1;
        text-align: center;
        font-size: 15px;
        color: #7f8c8d;
        padding: 16px 0;
        font-weight: 500;
        transition: all 0.3s ease;
        cursor: pointer;
        
        &.active {
          color: #667eea;
          background: rgba(102, 126, 234, 0.05);
          position: relative;
          
          &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 3px;
            background: #667eea;
            border-radius: 2px;
          }
        }

        &:active {
          background: rgba(102, 126, 234, 0.1);
        }
      }
    }

    .permissions-section,
    .rules-section {
      .reward-section,
      .penalty-section {
        background: white;
        border-radius: 16px;
        margin-bottom: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        overflow: hidden;

        .section-header {
          display: flex;
          align-items: center;
          padding: 20px 16px 16px 16px;
          border-bottom: 1px solid #f5f5f5;

          .section-icon {
            font-size: 20px;
            margin-right: 12px;
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
          }

          .section-title {
            font-size: 16px;
            font-weight: 600;
            color: #2c3e50;
            letter-spacing: 0.3px;
          }
        }

        .rules-list {
          .rule-item {
            display: flex;
            align-items: flex-start;
            padding: 16px;
            border-bottom: 1px solid #f5f5f5;

            &:last-child {
              border-bottom: none;
            }

            .rule-left {
              flex: 1;
              padding-right: 12px;

              .rule-name {
                font-size: 14px;
                color: #2c3e50;
                font-weight: 500;
                line-height: 1.4;
              }
            }

            .rule-right {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              min-width: 0;

              .rule-row {
                display: flex;
                align-items: center;
                margin-bottom: 4px;

                &:last-child {
                  margin-bottom: 0;
                }

                .rule-points {
                  font-size: 15px;
                  font-weight: 600;
                  letter-spacing: 0.3px;

                  &.positive {
                    color: #52c41a;
                  }

                  &.negative {
                    color: #ff4d4f;
                  }
                }

                .rule-unit {
                  color: #7f8c8d;
                  font-size: 12px;
                  margin-left: 4px;
                  font-weight: 400;
                }

                .rule-desc {
                  color: #7f8c8d;
                  font-size: 12px;
                  margin-left: 8px;
                  white-space: nowrap;
                  font-weight: 400;
                }
              }

              .rule-desc {
                color: #7f8c8d;
                font-size: 12px;
                margin-top: 4px;
                text-align: right;
                line-height: 1.4;
                font-weight: 400;
              }
            }
          }
        }
      }
    }

    .permissions-section {
      .permissions-list {
        .permission-item {
          display: flex;
          align-items: flex-start;
          padding: 16px;
          border-bottom: 1px solid #f5f5f5;

          &:last-child {
            border-bottom: none;
          }

          .permission-icon {
            width: 24px;
            height: 24px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            flex-shrink: 0;
            font-size: 12px;
            font-weight: 600;
            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
          }

          .permission-content {
            flex: 1;

            .permission-title {
              font-size: 15px;
              color: #2c3e50;
              margin-bottom: 8px;
              font-weight: 600;
              letter-spacing: 0.3px;
            }

            .permission-desc {
              font-size: 13px;
              color: #7f8c8d;
              line-height: 1.5;
              font-weight: 400;
            }
          }
        }
      }
    }
  }
}
</style> 